import Vue from "vue";
import {
  MessageBox,
  Row,
  Col,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Menu,
  MenuItem,
  Carousel,
  CarouselItem,
  Icon,
  Card,
  Table,
  Tree,
  TableColumn,
  Input,
  Checkbox,
  Button,
  Form,
  FormItem,
  Submenu,
  Select,
  Option,
  Pagination,
  Dialog,
  Tag,
  Radio,
  DatePicker,
  TimePicker,
  Message,
  Cascader,
  Loading,
  Alert,
  Tabs,
  TabPane,
  Upload,
  Calendar,
  RadioGroup,
  Popconfirm,
  Descriptions,
  DescriptionsItem,
  Timeline,
  TimelineItem,
  Badge,
  Steps,
  Step,
  Progress,
  Tooltip,
  Image,
  CheckboxGroup,
  Autocomplete,
} from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(Row);
Vue.use(Image);
Vue.use(Col);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Menu);
Vue.use(MenuItem);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Icon);
Vue.use(Card);
Vue.use(Table);
Vue.use(Tree);
Vue.use(TableColumn);
Vue.use(Input);
Vue.use(Checkbox);
Vue.use(Button);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Submenu);
Vue.use(Select);
Vue.use(Option);
Vue.use(Pagination);
Vue.use(Dialog);
Vue.use(Tag);
Vue.use(Radio);
Vue.use(DatePicker);
Vue.use(TimePicker);
Vue.use(Cascader);
Vue.use(Alert);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Upload);
Vue.use(Loading.directive);
Vue.use(Calendar);
Vue.use(RadioGroup);
Vue.use(Popconfirm);
Vue.use(Descriptions);
Vue.use(DescriptionsItem);
Vue.use(Timeline);
Vue.use(TimelineItem);
Vue.use(Badge);
Vue.use(Steps);
Vue.use(Step);
Vue.use(Progress);
Vue.use(Tooltip);
Vue.use(CheckboxGroup);
Vue.use(Autocomplete);
Vue.prototype.$loading = Loading.service;
Vue.prototype.$message = Message;
Vue.prototype.$confirm = MessageBox;
Vue.prototype.$msgbox = MessageBox;
